import React from 'react';


const FullPageLoader2 = ({ allowFullScreen }) => {


    const spinner = (
        <div className="w-8 h-8 border-b-2 rounded-full animate-spin border-primary2" />
    );

    if (allowFullScreen) {
        return (
            <div className="fixed top-0 right-0 z-[9999] flex items-center justify-center w-full h-full bg-[#a19f9f30]">
                {spinner}
            </div>
        );
    }
    return (
        <div className="absolute top-0 right-0 z-[20] flex items-center justify-center w-full h-full bg-[#a19f9f30]">
            {spinner}
        </div>
    );


}

export default FullPageLoader2